/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";

export const StripeSubscriptionQuery = gql`
  query StripeSubscriptionQuery {
    stripeSubscription: getStripeSubscription {
      exists
      status
      latestInvoice {
        paymentIntent {
          status
          clientSecret
        }
      }
      defaultCard {
        brand
        funding
        name
        last4
        exp_month
        exp_year
      }
    }
  }
`;

export const UpdateStripeSubscriptionMutation = gql`
  mutation UpdateStripeSubscription($plan: String!, $paymentMethodId: String) {
    stripeSubscription: updateStripeSubscription(
      plan: $plan
      paymentMethodId: $paymentMethodId
    ) {
      id
      exists
      status
      pendingSetupIntent {
        status
        clientSecret
      }
    }
  }
`;

export const updateStripePaymentCardMutation = gql`
  mutation updateStripePaymentCardMutation($paymentMethodId: String!) {
    stripeSubscription: updateStripePaymentCard(
      paymentMethodId: $paymentMethodId
    ) {
      id
      exists
      status
      pendingSetupIntent {
        status
        clientSecret
      }
    }
  }
`;

export const GetInvoicesQuery = gql`
  query($orgId: ID) {
    invoices: getInvoices(orgId: $orgId) {
      invoiceNumber
      currency
      total
      status
      created
      hostedInvoiceUrl
      items {
        plan
        periodStart
        periodEnd
      }
    }
  }
`;

export const GetUsageQuery = gql`
  query GetUsageQuery {
    usage: getUsage {
      periodStart
      periodEnd
      totalProtections
      appsProtected {
        appId
        time
      }
    }
  }
`;

export interface StripeSubscription {
  stripeSubscription: {
    id: string;
    exists: boolean;
    status?: string;
    defaultCard?: StripePaymentCard;
    pendingSetupIntent: StripeIntent;
    latestInvoice: StripeInvoice;
  };
}

interface StripeIntent {
  status: string;
  clientSecret: string;
}

export interface StripePaymentCard {
  brand: string;
  country: string;
  exp_month: number;
  exp_year: number;
  last4: string;
  funding: string;
  name?: string;
}

export interface PlanInput {
  newPlan: string;
}

export interface StripeInvoice {
  invoiceNumber: string;
  currency: string;
  total: number;
  status: string;
  hostedInvoiceUrl?: string;
  created: number;
  items: StripeInvoiceItem[];
  paymentIntent: StripeIntent;
}

export interface InvoiceData {
  invoices: StripeInvoice[];
}

export interface StripeInvoiceItem {
  plan: string;
  periodStart?: number;
  periodEnd?: number;
}
